module.exports = __webpack_public_path__ + "img/blog.982413da.svg";